import { useEffect, useState } from "react";
import withLoader from "../../layouts/WithLoader";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import BCService from "../../../services/BC";
import SalesService from "../../../services/SellingService";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import makeAnimated from 'react-select/animated';
import Select from "react-select";



const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const PayementAvanceBillWallet = ({ startLoading, stopLoading }) => {
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  // const [wallet, setWallet] = useState();
  const [wallets, setWallets] = useState([]);
  const [walletId, setWalletId] = useState();
  const [selectedOption, setSelectedOption] = useState(null);

  const [amount, setAmount] = useState();
  const animatedComponents = makeAnimated();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [walletSelectPlaceHolder, setWalletSelectPlaceHolder] =
    useState("Choisir...");


  const [walletSoldeSelectPlaceHolder, setWalletSoldeSelectPlaceHolder] =
    useState(null);

  useEffect(() => {
    const url = window.location.pathname.split("/")[1];
    if (url === "payerBill") {
      startLoading()
      TierAccountService.getWalletByTierFournisseur(getCurrentUserId(), localStorage.getItem("idTierWallet")).then((response) => {
        // setWallet(response.data.success);
        response.data.success.map((element) => {
          if (element?.id !== undefined) {
            setWallets((oldArray) => [
              ...oldArray,
              {
                value: element.id, label: element.title, customElements: {
                  solde: element.solde
                }
              },
            ]);
          }
          //here
        });
      }).catch((error) => {
        console.log("error", error)
      }).finally(() => {
        stopLoading();
      })
    } else {
      startLoading()
      TierAccountService.getWalletByTier(getCurrentUserId(), localStorage.getItem("idTierWallet")).then((response) => {
        // setWallet(response.data.success[0]);
        response.data.success.map((element) => {
          if (element?.id !== undefined) {
            setWallets((oldArray) => [
              ...oldArray,
              {
                value: element.id, label: element.title, customElements: {
                  solde: element.solde
                }
              },
            ]);
          }
          //here
        });
      }).catch((error) => {
        console.log("error", error)
      }).finally(() => {
        stopLoading();
      })
    }
  }, []);

  const changeAmount = (event) => {
    setAmount(event.target.value);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const payerBill = (e) => {
    const url = window.location.pathname.split("/")[1];
    if (url === "payerBill") {
      if (amount === "") {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : le montant est vide ");
      } else if (amount > localStorage.getItem("restToPay")) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : Le montant ne doit pas dépasser " + localStorage.getItem("restToPay"));
      } else {
        let payFactureOrAvance = {
          idUser: getCurrentUserId(),
          isFactureOrBDC: 1,
          idDocument: parseInt(localStorage.getItem("idBill")),
          isAvanceOrTotalPayement: 0,
          typePayement: 4,
          ammountPayed: amount,
          banqueAccountId: walletId,
          urlFile: "any",
        };
        startLoading();
        BCService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
            } else {
              setTimeout(() => {
                window.location.reload(true);
              }, 2000);
            }
          })
          .catch((error) => { })
          .finally(() => {
            stopLoading();
          });
      }

    } else {
      if (amount === "") {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : le montant est vide ");
      } else {
        let payementModel = {
          idUser: getCurrentUserId(),
          idDocument: parseInt(localStorage.getItem("idBill")),
          isAvanceOrTotalPayement: 0,
          isFactureOrBDC: 1,
          typePayement: 4,
          ammountPayed: amount,
          banqueAccountId: walletId,
          urlFile: "any",

        };
        startLoading();
        SalesService.payFactureOrBDC(payementModel)

          .then((response) => {
            console.log(response);
            if (response.data["error"]) {
              //   toast.error("Error : il ya un probléme");
            } else {
              setTimeout(() => {
                window.location.reload(true);
              }, 2000);
            }
          })
          .catch((error) => {

          })
          .finally(() => {
            stopLoading();
          });
      }

    }
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const onChangeSelectedId = (selectedOptionn) => {
    setSelectedOption();
    setWalletId(selectedOptionn.value);
    setWalletSelectPlaceHolder(selectedOptionn.label);
    setWalletSoldeSelectPlaceHolder(selectedOptionn.customElements.solde)

  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <label>Payement par Wallet: </label>
        </div>
      </div>
      <div className="row">

        <Select
          styles={styles}
          closeMenuOnSelect={true}
          components={animatedComponents}
          defaultValue={selectedOption}
          onChange={onChangeSelectedId}
          options={wallets}
          placeholder={walletSelectPlaceHolder}
        />
        {/* <div className="col-12">
          <label>Wallet: {wallet?.title} </label>
        </div> */}
        <br />
        <div className="col-12">
         
          {walletSoldeSelectPlaceHolder!=null && <div className="col-12">
            <label>Solde: {walletSoldeSelectPlaceHolder} DNT</label>
          </div>}
        </div>

      </div>

      <div class="row">
        <div class="col-md-4">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            class="form-control"
            placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>

        <br />
        <div class="col-12">
          <button
            type="submit"
            onClick={payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};
export default withLoader(PayementAvanceBillWallet);
